import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function LipidProfileForm() {
  const [form, setForm] = useState({
    name: "",
    ageSex: "",
    doctor: "",
    date: "",

    sCholestol: "",
    triglycerides: "",
    hdl: "",
    ldl: "",
    vldl: "",
    randomBloodSugar: "",
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  return (
    <>
      <div className="container my-3">
        <h3>LIPID PROFILE FORM</h3>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Pt. Name:</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={form.name}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Age/Sex:</label>
            <input
              type="text"
              className="form-control"
              name="ageSex"
              value={form.ageSex}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="row mb-2">
          <div className="col-md-6">
            <label>Ref. by Dr.:</label>
            <input
              type="text"
              className="form-control"
              name="doctor"
              value={form.doctor}
              onChange={handleChange}
            />
          </div>
          <div className="col-md-6">
            <label>Date:</label>
            <input
              type="date"
              className="form-control"
              name="date"
              value={form.date}
              onChange={handleChange}
            />
          </div>
        </div>

        <h5 className="mt-4">(LIPID PROFILE) - INVESTIGATION</h5>
        {[
          ["S. Cholestol (mg/dl)", "sCholestol"],
          ["Triglycerides (mg/dl)", "triglycerides"],
          ["HDL-Direct (mg/dl)", "hdl"],
          ["LDL-Cholesterol (mg/dl)", "ldl"],
          ["VLDL Cholesterol (mg/dl)", "vldl"],
          ["Random Blood Sugar (MG/DL)", "randomBloodSugar"],
        ].map(([label, name]) => (
          <div className="mb-2" key={name}>
            <label>{label}:</label>
            <input
              type="text"
              className="form-control"
              name={name}
              value={form[name]}
              onChange={handleChange}
            />
          </div>
        ))}

        <button className="btn btn-primary mt-3" onClick={() => window.print()}>
          🖨️ Print Report
        </button>
      </div>

      {/* Printable Report */}
      <div
        className="print-area container py-4"
        style={{ fontFamily: "Arial", fontSize: "14px" }}
      >
        <h2 className="text-center text-decoration-underline">
          LIPID PROFILE REPORT
        </h2>

        <div className="row mb-2">
          <div className="col-6">
            <strong>Pt. Name:</strong> {form.name}
          </div>
          <div className="col-6">
            <strong>Age/Sex:</strong> {form.ageSex}
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-6">
            <strong>Ref. by Dr.:</strong> {form.doctor}
          </div>
          <div className="col-6">
            <strong>Date:</strong> {form.date}
          </div>
        </div>

        <h5 className="text-decoration-underline">(LIPID PROFILE)</h5>
        <table className="table table-bordered">
          <tbody>
            <tr>
              <td>S. Cholestol</td>
              <td>{form.sCholestol}</td>
              <td>mg/dl (125 to 200 mg/dl)</td>
            </tr>
            <tr>
              <td>Triglycerides</td>
              <td>{form.triglycerides}</td>
              <td>mg/dl (25 to 200 mg/dl)</td>
            </tr>
            <tr>
              <td>HDL-Direct</td>
              <td>{form.hdl}</td>
              <td>mg/dl (35 to 80 mg/dl)</td>
            </tr>
            <tr>
              <td>LDL-Cholesterol</td>
              <td>{form.ldl}</td>
              <td>mg/dl (85 to 130 mg/dl)</td>
            </tr>
            <tr>
              <td>VLDL Cholesterol</td>
              <td>{form.vldl}</td>
              <td>mg/dl (5 to 40 mg/dl)</td>
            </tr>
            <tr>
              <td>Random Blood Sugar</td>
              <td>{form.randomBloodSugar}</td>
              <td>MG/DL (80 to 140 mg/dl)</td>
            </tr>
          </tbody>
        </table>

        <p className="text-end mt-4">
          <strong>*****END OF REPORTS*****</strong> &nbsp;&nbsp;&nbsp;&nbsp;
          Technologist
        </p>
      </div>
    </>
  );
}

export default LipidProfileForm;
